import { useMemo } from 'react'
import { io } from 'socket.io-client'

/**
 * WebSocket hook for real-time communication.
 * Currently disabled to prevent connection errors.
 * When ready to use WebSockets, uncomment the socket initialization code.
 */
const useSocket = () => {
  // Using useMemo to prevent recreating the socket on each render
  const socket = useMemo(() => {
    // WebSockets are currently disabled to prevent connection errors
    // When WebSocket server is ready, replace with the following:
    // return io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:8090', {
    //     autoConnect: false, // Only connect when explicitly called
    //     transports: ['websocket']
    // });

    // Return null to indicate WebSockets are disabled
    return null
  }, [])

  return socket
}

export default useSocket
